import React from 'react';
import Header from '../../components/header'
import { Button } from 'antd';
import { Icon } from '@iconify/react';
import './home.less'
import ProfileImg from "../../asset/profile.png"
import { Link } from 'react-router-dom';



const Index = () => {
    return (
        <div className='homeWrapper screen-height bg-black container fixed'>
        <Header/>
        <div className='w-80'>   
        <div className='flex'>
        <div>
                <img className='image' src={ProfileImg} alt='Tefe'/>
            </div>
        <div className='textWrapper'>
            <div className='mainText'>
            <p className='tefe'>Mebuiefene Tefe</p>
            <h1>Front</h1>
            <h1>End <span className='textDe'>En</span><span>g</span><span className='textDe'>ineer</span></h1>
            {/* <p>Hello World <span className='waving'>👋</span>, Welcome to my portfolio</p> */}
            </div>
            <div className='buttonWrapper'>
            <Link to="/about"><Button>About Me <Icon icon="gg:arrow-long-right" width="18" className='icon' /></Button></Link>
            {/* <a href={cv}  download="Mebuiefene Tefe.pdf"> <Button className='cvBtn'>Download CV <Icon icon="gg:arrow-long-down" width="18" className='icon' /></Button></a> */}
            </div>
           
            </div>
           
        </div>
        <div className='iconWrapper'>
            <a className="f-icon" href='https://www.linkedin.com/in/tefe-mebuiefene-31b0831b4/' target="_blank" rel="noreferrer"><Icon icon="simple-icons:linkedin"  className='icon' /></a>
            <a href="https://github.com/glorytefe" target="_blank" rel="noreferrer"><Icon icon="simple-icons:github"  className='icon'/></a>
            <a href="https://twitter.com/TefeGlory?t=cn-KpaTHxopXiRay4LP34Q" target="_blank" rel="noreferrer"><Icon icon="simple-icons:twitter"  className='icon'/></a>

            </div>
            </div>
        </div>
    );
}

export default Index;
